export default __webpack_public_path__ + "static/media/borrar.7ad715c3.svg";